import React from 'react'

import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import context from './context'

export const ContextProvider = ({ history, location, children }) => (
  <context.Provider
    value={{
      history,
      location,
    }}
  >
    {children}
  </context.Provider>
)
ContextProvider.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  children: PropTypes.node,
}

export default withRouter(ContextProvider)
